export default {
  user: (state) => state.user,
  token: (state) => state.token,
  userLoading: (state) => state.userLoading,
  reallocationDateLimit: (state) => state.reallocationDateLimit,
  yearSelectedContent: (state) => state.yearSelectedContent,
}
